import React, { useCallback, useEffect } from "react";
import InputField from "app/components/InputField";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { MODES } from "utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "app/containers/Questions/redux/slice";
import { selectAnswer } from "app/containers/Questions/redux/selector";
import { MixedLetterAnswer } from "app/containers/Questions/types";
import { useTranslation } from "react-i18next";
import useDebounceEffect from "utils/hooks/useDebounceEffect";
import { Box, IconButton, InputAdornment } from "@mui/material";
import DeleteForeverTwoToneIcon from "@mui/icons-material/DeleteForeverTwoTone";
import PrimaryButton from "app/components/Buttons/PrimaryButton";
import AddIcon from "@mui/icons-material/Add";
import { VALID_CHARS_REGEX_FOR_MIXED_LETTER } from "./constants";
const Data: MixedLetterAnswer = {
  _id: "",
  word: "",
};
const MAX_ANSWER = 2;
const MixedLetters = ({
  disabled,
  mode,
}: {
  disabled?: boolean;
  mode: MODES;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const answer = useSelector(selectAnswer);

  const maxNotReached = (answer.mixed_letter?.length ?? 0) < MAX_ANSWER;
  useDebounceEffect(
    () => {
      if (!answer?.mixed_letter?.length) {
        dispatch(actions.setMixedLetterAnswer(Data));
        return;
      }

      return () => {};
    },
    [answer?.mixed_letter],
    100
  );

  const handleAddAnswer = () => {
    if (maxNotReached) {
      dispatch(actions.setMixedLetterAnswer(Data));
      return;
    }
  };

  const disabledDelete = answer?.mixed_letter?.length == 1 || disabled;
  return (
    <Box  sx={{ marginBottom: "200px" }} >
      <Grid2 spacing={3} container>
        {answer.mixed_letter?.map((item, index) => (
          <Grid2 xs={6} key={index}>
            <InputField
              label={`${t("QUESTIONS.FORM.LABELS.WORD", { num: index + 1 })}`}
              placeholder={`${t("QUESTIONS.FORM.LABELS.ENTER_WORD")} ${
                index + 1
              }`}
              name="wordOne"
              fullWidth={true}
              borderColor="#D7D7E0"
              isDisable={disabled}
              lightPlaceholder
              labelStyle={{
                color: "#5E6781",
                fontSize: "14px",
              }}
              value={item?.word}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      sx={{
                        width: "40px",
                        height: "24px",
                        borderRadius: "4px",
                      }}
                      disabled={disabledDelete}
                      onClick={() => {
                        dispatch(
                          actions.setDeleteAnswer({
                            index: index,
                            type: "mixed_letter",
                          })
                        );
                      }}
                    >
                      <DeleteForeverTwoToneIcon
                        sx={{
                          fontSize: "16px",
                          color: disabledDelete ? "#ccc" : "#E24399",
                        }}
                      />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => {
                const newValue = e.target.value;
                if (VALID_CHARS_REGEX_FOR_MIXED_LETTER.test(newValue)) {
                  dispatch(
                    actions.setUpdateAnswer({
                      index: index,
                      key: "word",
                      type: "mixed_letter",
                      value: newValue,
                    })
                  );
                }
    
              }}
            />
          </Grid2>
        ))}
      </Grid2>
      <Grid2>
        <Grid2 xs={6} justifyContent={'flex-end'} display={'flex'}>
          <PrimaryButton
            sx={{ width: 145 }}
            startIcon={<AddIcon />}
            disabled={!maxNotReached}
            onClick={handleAddAnswer}
            label={t("COMMON.BUTTONS.ADD_NEW_ANSWER")}
          />
        </Grid2>
        <Grid2 xs={6}> </Grid2>
      </Grid2>
    </Box>
  );
};

export default MixedLetters;
